module.exports = __webpack_public_path__ + "img/EgyptTechAxeman2_ua.1c4964ea.webp";